import { Heading, SvgIcon, TextLink, Text } from '@cinch-labs/design-system'

import styles from './get-in-touch.module.css'

const GetInTouch: React.FC = () => (
  <section className={styles.container}>
    <Heading className={styles.title}>Need to get in touch?</Heading>

    <Text className={styles.body}>
      Call, email or WhatsApp, we’re here to help.
    </Text>

    <div className={styles.cardGroup}>
      <div className={styles.card}>
        <SvgIcon name="mail" />
        <Heading element="h3" className={styles.cardHeading}>
          Customer Support
        </Heading>
        <TextLink
          href="mailto:hello@cinch.co.uk"
          target="_blank"
          rel="noreferrer"
          hasNoLine
        >
          hello@cinch.co.uk
        </TextLink>

        <TextLink
          href="tel:+443330154101"
          target="_blank"
          rel="noreferrer"
          hasNoLine
        >
          0333 015 4101
        </TextLink>

        <TextLink
          href="https://wa.me/447831910589"
          target="_blank"
          rel="noreferrer"
          hasNoLine
        >
          WhatsApp
        </TextLink>
      </div>

      <div className={styles.card}>
        <SvgIcon name="edit" />
        <Heading element="h3" className={styles.cardHeading}>
          Write to us
        </Heading>
        <Text>
          Cinch Cars Limited
          <br /> Form 2, 18 Bartley Wood
          <br /> Business Park, Bartley Way,
          <br /> Hook, Hampshire RG27 9XA
        </Text>
      </div>
    </div>
  </section>
)

export default GetInTouch
